var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{staticClass:"mb-5",attrs:{"event-id":_vm.event_id},on:{"select":_vm.select}}),(_vm.report && !_vm.loading)?_c('Report',{attrs:{"report":_vm.report,"event-id":_vm.event_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }